import React, {useState} from "react";

import QcLogicFormField from "./QcLogicFormField";
import {hasPermission} from "../../../../helpers/utils/AccessControlUtils";

const UpdateQcLogicForm = () => {

    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "QC Logics", url: "/qc-logics"},
            {content: "Update Qc Logic", url: ""}
        ]
    )
    return (

        <>
            <QcLogicFormField crumbs={crumbs} title={"Update Qc Rule"} btnText={"Update"}
                              isEditable={hasPermission(["LOGIC-U"])}/>
        </>

    );
};

export default UpdateQcLogicForm;
